import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ToastProvider } from './components/ui/Toast'
import { TooltipProvider } from './components/ui/Tooltip'
import { router } from './routes'
import { ApiError } from './api/errors'

/** Providers and the router. Nothing else lives here — this file should stay */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Refetching when the window regains focus matters more than.
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Never retry an authorisation failure. A 401 has already triggered.
        if (error instanceof ApiError) {
          if (error.status === 401 || error.status === 403 || error.status === 404) return false
          if (error.status === 429) return false
        }
        return failureCount < 2
      },
    },
    mutations: {
      // A mutation is a deliberate user action. Retrying it automatically.
      retry: false,
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ToastProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </ToastProvider>
      </TooltipProvider>
    </QueryClientProvider>
  )
}
